import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <>
      {/* Barra Superior Granate */}
      <div className="bg-brand-granate text-white text-center py-3 px-4" data-id="element-130">
        <p className="font-heading text-sm font-medium tracking-wide" data-id="element-131">
          💃 ATENCIÓN: INSTRUCTORAS DE SEVILLANAS
        </p>
      </div>

      <div className="pt-8 pb-6 px-4 max-w-4xl mx-auto text-center" data-id="element-132">
        <h1 className="font-display text-brand-title md:text-6xl font-bold tracking-tight mb-4 text-[32px]" data-id="element-133">
          ¿Te quita tiempo planificar tus clases? Resuélvelo hoy.
        </h1>

        <div className="my-4 flex justify-center" data-id="element-134">
          <img src="https://cdn.magicpatterns.com/uploads/q6Eabv4Ek1aVnRwGDcX6Xt/mockup_sevillanas_webp-removebg-preview.webp" alt="El Manual del Instructor de Sevillanas PRO" width="800" height="800" fetchPriority="high" loading="eager" decoding="async" className="w-full max-w-2xl" style={{
          filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.25))'
        }} data-id="element-135" />
        </div>

        <p className="md:text-2xl text-brand-subtitle font-semibold mb-4 tracking-wide font-body text-[16px]" data-id="element-136">
          El Sistema con planificaciones, técnica y gestión listas desde el
          primer día.
        </p>

        <p className="text-brand-text mb-4 font-body text-[16px]" data-id="element-137">
          Recupera tu tiempo libre y tus noches.
        </p>

        <div className="flex items-center justify-center gap-2 mb-3 text-sm" data-id="element-138">
          <div className="flex text-brand-cta" data-id="element-139">⭐⭐⭐⭐⭐</div>
          <span className="text-brand-subtitle font-medium" data-id="element-140">4.9/5</span>
          <span className="text-brand-textMuted" data-id="element-141">·</span>
          <span className="text-brand-text font-medium text-[12px]" data-id="element-142">
            (+320 Valoraciones Verificadas)
          </span>
        </div>

        <div className="text-brand-text font-medium mb-4 text-[12px]" data-id="element-143">
          🔥 47 instructoras han descargado este Pack hoy
        </div>

        <button onClick={scrollToPricing} className="bg-gradient-red hover:opacity-90 text-white font-bold text-xl md:text-2xl py-4 px-8 rounded-btn transition-opacity w-full md:w-auto mb-3 tracking-wide shadow-red-glow" data-id="element-144">
          🚀QUIERO MI MANUAL AHORA
        </button>

        <div className="text-brand-textMuted font-medium text-sm tracking-wide" data-id="element-145">
          ⚡ Acceso Inmediato • 🛡️ Garantía 7 Días • 💳 Pago Único
        </div>
      </div>
    </>;
}